<template>
  <div>
    <v-data-table
      :headers="dessertHeaders"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="id"
      :items="recivedkycdata"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>KYC</v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:item.id_type_code="{ item }">
        {{ valueFormatter(item.id_type_code) }}
      </template>
      <template v-slot:item.id_number="{ item }">
        {{ valueFormatter(item.id_number) }}
      </template>

      <template v-slot:item.front_page="{ item }">
        <v-avatar
          v-if="item.front_page !== '' && item.front_page !== null"
          size="36px"
          @click="handleImageViewer(item.front_page)"
        >
          <img v-if="item.front_page" alt="Avatar" :src="item.front_page" />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
        <v-avatar v-else color="gray" size="24px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                alt="Avatar"
                :src="'https://cdn2.iconfinder.com/data/icons/documents-and-files-v-2/100/doc-03-512.png'"
              />
            </template>
            <span>No File</span>
          </v-tooltip>
        </v-avatar>
        <v-btn
          v-if="item.front_page !== '' && item.front_page !== null"
          depressed
          color="primary"
          icon
          small
          title="Download first page"
          @click.native="DownloadImage('FRONT_PAGE')"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.back_page="{ item }">
        <v-avatar
          v-if="item.back_page !== '' && item.back_page !== null"
          size="36px"
          @click="handleImageViewer(item.back_page)"
        >
          <img v-if="item.back_page" alt="Avatar" :src="item.back_page" />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
        <v-avatar v-else color="gray" size="24px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                alt="Avatar"
                :src="'https://cdn2.iconfinder.com/data/icons/documents-and-files-v-2/100/doc-03-512.png'"
              />
            </template>
            <span>No File</span>
          </v-tooltip>
        </v-avatar>
        <v-btn
          v-if="item.back_page !== '' && item.back_page !== null"
          depressed
          color="primary"
          icon
          small
          title="Download last page"
          @click.native="DownloadImage('BACK_PAGE')"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.selfie="{ item }">
        <v-avatar
          v-if="item.selfie !== 'nan' && item.selfie !== null"
          size="36px"
          @click="handleImageViewer(item.selfie)"
        >
          <img v-if="item.selfie" alt="Avatar" :src="item.selfie" />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
        <v-avatar v-else color="gray" size="24px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                alt="Avatar"
                :src="'https://cdn2.iconfinder.com/data/icons/documents-and-files-v-2/100/doc-03-512.png'"
              />
            </template>
            <span>No File</span>
          </v-tooltip>
        </v-avatar>
        <v-btn
          v-if="item.selfie !== '' && item.selfie !== null"
          depressed
          color="primary"
          icon
          small
          title="Download Selfie"
          @click.native="DownloadImage('FACE_IMAGE')"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.kyc_status="{ item }">
        <div class="d-flex align-center">
          <v-btn
            depressed
            :color="getColor(item.kyc_status)"
            block
            class="no-uppercase flex-grow-1"
            dense
            small
            outlined
            :disabled="isKycStatusDisabled(item)"
            @click="updateStatus(item)"
          >
            {{ item.kyc_status ? item.kyc_status : "Update status" }}
            <v-icon right small>mdi-content-save-edit-outline</v-icon>
          </v-btn>
          <v-tooltip bottom max-width="320">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                color="primary"
                class="ml-2"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <div class="font-weight-medium mb-1">
              Required to update KYC status
            </div>
            <div>ID Number, ID Type, Front Page and Selfie</div>
            <div v-if="missingKycFields(item).length" class="mt-1">
              Missing: {{ missingKycFields(item).join(", ") }}
            </div>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <table>
            <tbody>
              <tr>
                <template v-if="!isMykadDocument(item)">
                  <td>Issue Date</td>
                  <td>
                    <b>{{ valueFormatter(item.id_issue_date) }}</b>
                  </td>
                  <td>Expiry Date</td>
                  <td>
                    <b>{{ valueFormatter(item.id_expire_date) }}</b>
                  </td>
                </template>
                <td>Verified By</td>
                <td>
                  <b>{{ valueFormatter(item.verified_by) }}</b>
                </td>
                <td>Verified Date</td>
                <td>
                  <b>{{ valueFormatter(item.verified_date) }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </template>
    </v-data-table>

    <div class="text-center">
      <v-dialog persistent v-model="dialog" width="500">
        <v-card>
          <v-toolbar color="secondary" dark flat dense>
            <span> Kyc Status</span>
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closeStatus()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="mt-2">
            <v-form v-model="valid" ref="UserListtatus">
              <v-row no-gutters class="d-block">
                <v-col cols="12" md="12">
                  <label class="my-0 rounded required"> Kyc Status </label>
                  <v-select
                    :items="items"
                    class="rounded"
                    :rules="FieldRequired('Kyc Status')"
                    v-model="kyc_status"
                    placeholder="Select Kyc Status"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="d-block">
                <v-col cols="12" md="12">
                  <label class="my-0 rounded required">Select Remarks </label>
                  <v-select
                    v-model="selectedReamarks"
                    :items="
                      kyc_status === 'Rejected'
                        ? kycRejectedRemarks
                        : kycApprovedRemarks
                    "
                    placeholder="Select Remarks"
                    :rules="FieldRequired('Remarks')"
                    class="rounded"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row
                no-gutters
                class="d-block"
                v-if="selectedReamarks === 'Others'"
              >
                <v-col cols="12" md="12">
                  <label class="my-0 rounded required">Other Remarks </label>
                  <v-textarea
                    placeholder="Enter Other Remarks"
                    :rules="FieldRequired('Other Remarks')"
                    class="rounded"
                    dense
                    outlined
                    required
                    v-model="remarks"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider class="mb-0"></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              outlined
              small
              color="primary"
              @click="closeStatus()"
              ><v-icon small class="me-2">mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn small depressed color="primary" @click="kycstatus()">
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '635',
        PicWidth: 1000,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </div>
</template>
<script>
import imageViewer from "@/utils/imageViewer.vue";
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import userService from "@/services/UserService/userService.js";
import commonService from "@/services/CommonService/commonService.js";
import { FieldRequired } from "@/utils/validation.js";
export default {
  mixins: [alerts],
  name: "",
  components: {
    imageViewer,
    Loading,
  },

  props: ["kycData"],

  data() {
    return {
      FieldRequired,
      dialogs: false,
      loader: false,
      valid: true,
      kyc_status: "",
      remarks: "",
      businessKYCList: [],
      recivedkycdata: [],
      items: [
        { text: "Approved", value: "Approved" },
        { text: "Rejected", value: "Rejected" },
      ],
      docs_LIST: [],
      expanded: [],
      singleExpand: false,
      dialog: false,
      imageViewerUrl: "",
      isImageViewer: false,
      imageDialog: false,
      imagePreviewLink: null,
      dessertHeaders: [
        {
          text: "ID Type",
          align: "start",
          sortable: false,
          value: "id_type_code.value",
        },
        { text: "ID Number", value: "id_number" },
        { text: "Front ID", value: "front_page" },
        { text: "Back ID", value: "back_page" },
        { text: "Selfie ", value: this.valueFormatter("selfie") },
        { text: "Kyc Status", value: "kyc_status" },
        { text: "Remarks", value: "remarks" },
        { text: "Kyc Type", value: "kyc_type" },
        { text: "", value: "data-table-expand" },
      ],

      kycApprovedRemarks: [],
      selectedReamarks: "",
      kycRejectedRemarks: [],
    };
  },
  watch: {
    kycData(newval) {
      if (newval) {
        this.recivedkycdata = newval;
      }
    },
  },
  mounted() {
    this.getRemarksDropdown("KSAR");
    this.getRemarksDropdown("KSRR");
    this.$emit("getkycData");
  },
  methods: {
    isMykadDocument(item) {
      const idType = item && item.id_type_code;
      const label =
        idType && typeof idType === "object"
          ? idType.value || idType.text || idType.name
          : idType;
      const normalizedLabel = String(label || "")
        .replace(/[\s_-]/g, "")
        .toUpperCase();
      return normalizedLabel === "MYKAD";
    },
    isKycStatusDisabled(item) {
      return this.missingKycFields(item).length > 0;
    },
    missingKycFields(item) {
      const requiredFields = [
        { key: "id_number", label: "ID Number" },
        { key: "id_type_code", label: "ID Type" },
        { key: "front_page", label: "Front Page" },
        { key: "selfie", label: "Selfie" },
      ];
      return requiredFields
        .filter((field) => !item || this.isMissingKycValue(item[field.key]))
        .map((field) => field.label);
    },
    isMissingKycValue(value) {
      if (value === null || value === undefined) return true;
      if (typeof value === "object") return Object.keys(value).length === 0;
      const normalizedValue = String(value).trim().toLowerCase();
      return ["", "nan", "null", "undefined"].includes(normalizedValue);
    },
    closeStatus() {
      this.dialog = false;
    },
    updateStatus(item) {
      console.log(item);
      this.dialog = true;
      this.kyc_status = item.kyc_status ? item.kyc_status : null;
    },

    valueFormatter(value) {
      if (value !== "" && value !== null) {
        return value;
      }
      return "-";
    },
    getColor(kyc_status) {
      console.log("kyc_status", kyc_status);
      if (kyc_status === "Approved") return "green";
      else return "orange";
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },

    async DownloadImage(image_type) {
      try {
        const responseData = await userService.downloadKycDocs({
          customer_id: this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid,
          document_type: image_type,
        });
        if (responseData.status === 200) {
          console.log("responseData", responseData);
          var a = document.createElement("a"); //Create <a>
          a.href = responseData.request.responseURL; //Image Base64 Goes here
          a.download = "Image.png"; //File name Here
          a.click();
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getRemarksDropdown(code) {
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          if (code === "KSAR") {
            this.kycApprovedRemarks = responseData.data.data.map((i) => {
              return i.value;
            });
          } else if (code == "KSRR") {
            this.kycRejectedRemarks = responseData.data.data.map((i) => {
              return i.value;
            });
          }
        }
        console.log("docs_LIST", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    async kycstatus() {
      console.log("dd", this.kyc_status);
      const validate = this.$refs.UserListtatus.validate();
      if (validate === true) {
        const remarks =
          this.selectedReamarks === "Others"
            ? this.remarks
            : this.selectedReamarks;
        try {
          const responseData = await userService.prfileKYCstatus(
            this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid,
            this.kyc_status,
            remarks,
          );
          if (responseData.data.status_code === 200) {
            this.showAlertSuccess(responseData.data.message);
            this.$emit("getkycData");
            this.$refs.UserListtatus.reset();
            this.dialog = false;
          } else {
            this.showAlertError(responseData.data.message);
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-btn {
  position: absolute !important;
  z-index: 999;
  top: 135px;
  color: cadetblue;
  background: blueviolet;
  background: rgb(125, 198, 163);
  background: linear-gradient(
    50deg,
    rgba(125, 198, 163, 1) 0%,
    rgba(35, 216, 227, 1) 72%
  );
}

.avatar-shadow {
  box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
  -moz-box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
}

table {
  font-family: "Open Sans", sans-serif;
  border: none;
  width: 100%;

  tbody {
    td {
      text-align: left;
      padding: 3px;
      vertical-align: middle;
      font-size: 15px;
      font-weight: normal;
      border: none;
      margin: 5px;
    }
  }
}

label {
  font-size: 15px;
  color: black;
}
v-data-table >>> div > table {
  border-spacing: 0 0.5rem;
}
</style>
